/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StatusCategory = {
    Completed: 'Completed',
    Received: 'Received',
    Cancelled: 'Cancelled'
} as const;
export type StatusCategory = typeof StatusCategory[keyof typeof StatusCategory];


export function instanceOfStatusCategory(value: any): boolean {
    for (const key in StatusCategory) {
        if (Object.prototype.hasOwnProperty.call(StatusCategory, key)) {
            if (StatusCategory[key as keyof typeof StatusCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StatusCategoryFromJSON(json: any): StatusCategory {
    return StatusCategoryFromJSONTyped(json, false);
}

export function StatusCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusCategory {
    return json as StatusCategory;
}

export function StatusCategoryToJSON(value?: StatusCategory | null): any {
    return value as any;
}

export function StatusCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): StatusCategory {
    return value as StatusCategory;
}

